import axios from '../config/axios';


export async function crearFormularioEnvioDeMensajes(tipo_esquema, creado_por) {
  return await axios.post(`/planes_de_trabajo/notificaciones/api/v3/crear`, {
    tipo_esquema,
    creado_por
  });
};

export async function consultarEstructuraFormularioEnvioDeMensajes(tipo_esquema, docId) {
  return await axios.get(`/planes_de_trabajo/notificaciones/api/v3/leer`, {
    params: {
      tipo_esquema,
      docId
    },
  });
}

export async function actualizarFormularioEnvioDeMensajes(key, docId, creado_por, variables) {
  return await axios.put(`/planes_de_trabajo/notificaciones/api/v3/actualizar`, {
      key,
      docId,
      creado_por,
      variables
  });
}

export async function enviarMensaje(docId) {
  return await axios.get('/mensajeria/api/v1/leer_formulario_envio', {
    params: {
      docId
    }
  })
}




// WEBPACK FOOTER //
// ./src/apiService/request/crudEnvioDeMensajes.js